<app>
  <!--
    If you whant to use Slash based routes like http://localhost:3000/home
    Just remove the 'base' and 'initialRoute' bellow, and remove '#' from hrefs
    NOTE: gitlab doesn't have support for SPA. For gitlab page use Hash based routes '#'
  -->
  <router base={base} initialRoute={initialRoute}>
    <route path="(.*)">
      <main-nav route={route}/>
    </route>

    <pg-not-found/>

    <route each={r in routes} path={r.path}>
      <div is={r.component} route={route}/>
    </route>

    <main-footer/>
  </router>

  <script>
    import './cookie-term'
    
    // App style
    import './app.scss'

    // Pages
    import PgHome from './pages/pg-home.riot'
    import PgUnits from './pages/pg-units.riot'
    import PgAbout from './pages/pg-about.riot'
    import PgSolutions from './pages/pg-solutions.riot'
    import PgNotFound from './pages/pg-not-found.riot'
    import PgPrivacyPolicy from './pages/pg-privacy-policy.riot'

    // Components
    import MainNav from './components/main-nav.riot'
    import MainFooter from './components/main-footer.riot'

    import { Route, Router } from '@riotjs/route'

    import routes from './routes'

    // Using full path because at start
    // '@riotjs/route' is mounting and updating for relative paths
    const loc = window.location
    const hashPath = loc.hash || '#/'
    const pathName = (loc.pathname + `/`).replace(`//`, `/`)
    const initialRoute = `${loc.origin}${pathName}${hashPath}`

    // Set route base with full path, because gitlab run on sub paths like
    // http://localhost:3000/subpath/ so our routes gonna be http://localhost:3000/subpath/#/home
    const base = initialRoute.replace(/#.*/i, '') + '#'

    export default {
      components: {
        PgHome,
        PgUnits,
        PgAbout,
        PgSolutions,
        PgPrivacyPolicy,
        PgNotFound,
        MainNav,
        MainFooter,
        Route,
        Router
      },
      routes,
      initialRoute, base,
      onBeforeUpdate() {
        console.log('[app] updating')
      }
    }
  </script>
</app>
